export const ANON = 'without_registration';
export const WITH_REG = 'with_registration';
